import { Button, Radio, Select, Tooltip } from '@mantine/core'
import { useEffect } from 'react'

import { API_PARAMS } from '../config/consts'
import useGetFloorList from '../hooks/api/useGetFloorList'
import useGetSiteGroups from '../hooks/api/useGetSiteGroups'
import useGetSiteList from '../hooks/api/useGetSiteList'
import useLocationDateTimeForm from '../hooks/useLocationDateTimeForm'
import useLocationDateTimeRelayForm from '../hooks/useLocationDateTimeRelayForm'
import DatePickerInput from './DatePickerInput'

function LocationDateTimeForm() {
  const { form, setForm } = useLocationDateTimeForm()
  const { relay, setRelay } = useLocationDateTimeRelayForm()

  const { sites } = useGetSiteList()
  const { floors } = useGetFloorList(relay.siteId)
  const { siteGroups } = useGetSiteGroups()

  useEffect(() => {
    setRelay({ ...form })
  }, [form, setRelay])

  const applyChange = () => {
    setForm({ ...relay })
  }

  // サイト・サイトグループ・フロア選択のセレクトボックスにTooltip追加。
  // デフォルトで値が入っているので、セレクトボックス内をClearできるようにclearableを追加。
  // サイトグループ選択で検索ができなかったので、searchableを追加。
  return (
    <div className='flex items-center justify-between w-full h-36 bg-white p-4'>
      <div className='flex flex-col gap-4 p-4'>
        <Radio.Group value={relay.radio} onChange={(value) => setRelay((prev) => ({ ...prev, radio: value }))}>
          <div className='flex gap-4 px-2'>
            <Radio label='サイト選択' color='#00CC00' value='site' />
            <Radio label='サイトグループ選択' color='#00CC00' value='siteGroup' />
          </div>
        </Radio.Group>
        <div className='flex gap-4'>
          {relay.radio === 'site' ? (
            <>
              <Tooltip
                offset={5}
                withArrow
                arrowOffset={10}
                arrowSize={5}
                transitionProps={{transition: 'pop'}}
                label={relay.siteId === API_PARAMS.SELECT_ALL ? '全サイト' : sites?.find((s) => s.siteID.toString() === relay.siteId)?.name || '選択してください'}
              >
                <Select
                  className='w-48'
                  label='サイトを選択'
                  placeholder='選択してください'
                  data={[
                    { value: API_PARAMS.SELECT_ALL, label: '全サイト' },
                    // サイトの表示順を新しい順に変更する処理実装。
                    ...(sites?.map((s) => ({ value: s.siteID.toString(), label: s.name })) || []).reverse(),
                  ]}
                  defaultValue={API_PARAMS.SELECT_ALL}
                  value={relay.siteId}
                  onChange={(value) => setRelay((prev) => ({ ...prev, siteId: value }))}
                  searchable
                  clearable
                  style={{ width: '400px'}}
                />
              </Tooltip>
              <Tooltip
                offset={5}
                withArrow
                arrowOffset={10}
                arrowSize={5}
                transitionProps={{transition: 'pop'}}
                label={relay.floorId === API_PARAMS.SELECT_ALL ? '全フロア' : floors?.find((f) => f.floorID.toString() === relay.floorId)?.name || '選択してください'}
              >
                <Select
                  className='w-40'
                  label='フロアを選択'
                  placeholder='選択してください'
                  data={[
                    { value: API_PARAMS.SELECT_ALL, label: '全フロア' },
                    // フロアの表示順を新しい順に変更する処理実装。
                    ...(floors?.map((f) => ({ value: f.floorID.toString(), label: f.name })) || []).reverse(),
                  ]}
                  defaultValue={API_PARAMS.SELECT_ALL}
                  value={relay.floorId}
                  onChange={(value) => setRelay((prev) => ({ ...prev, floorId: value }))}
                  searchable
                  clearable
                />
              </Tooltip>
            </>
          ) : (
            <Tooltip
              offset={5}
              withArrow
              arrowOffset={10}
              arrowSize={5}
              transitionProps={{transition: 'pop'}}
              label={relay.siteGroupId === API_PARAMS.SELECT_ALL ? '全サイトグループ' : siteGroups?.siteGroups.find((s) => s.groupId.toString() === relay.siteGroupId)?.groupName || '選択してください'}
            >
              <Select
                className='w-48'
                label='サイトグループを選択'
                placeholder='選択してください'
                data={[
                  { value: API_PARAMS.SELECT_ALL, label: '全サイトグループ' },
                  // サイトグループの表示順を新しい順に変更する処理実装。
                  ...(siteGroups?.siteGroups.map((s) => ({ value: s.groupId.toString(), label: s.groupName })) || []).reverse(),
                ]}
                defaultValue={API_PARAMS.SELECT_ALL}
                value={relay.siteGroupId}
                onChange={(value) => setRelay((prev) => ({ ...prev, siteGroupId: value }))}
                searchable
                clearable
                style={{ width: '400px'}}
              />
            </Tooltip>
          )}
          <Select
            className='w-40'
            label='レポート日付範囲'
            placeholder='選択してください'
            data={[
              { value: '1', label: '前日' },
              { value: '7', label: '過去7日' },
              { value: '30', label: '過去30日' },
              { value: '9', label: 'カスタム' },
            ]}
            value={relay.range}
            onChange={(value) => setRelay((prev) => ({ ...prev, range: value }))}
          />
          <DatePickerInput
            className={`${relay.range !== '9' ? 'invisible' : 'visible'} w-40`}
            label='開始日'
            value={relay.fromDate}
            onChange={(value) => setRelay((prev) => ({ ...prev, fromDate: value }))}
          />
          <DatePickerInput
            className={`${relay.range !== '9' ? 'invisible' : 'visible'} w-40`}
            label='終了日'
            value={relay.toDate}
            onChange={(value) => setRelay((prev) => ({ ...prev, toDate: value }))}
          />
        </div>
      </div>
      <div className='flex items-end h-full pb-10'> {/* この行を追加 */}
        <Button className='w-auto' color='#00CC00' onClick={applyChange}>
          分析を実行する
        </Button>
      </div> {/* この行を追加 */}
    </div>
  )
}

export default LocationDateTimeForm
